var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCouponTag = function SvgIconCouponTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388E3C",
    d: "m7.178.575 7.424 1.06 1.061 7.426-6.894 6.894a.75.75 0 0 1-1.06 0L.283 8.53a.75.75 0 0 1 0-1.06zm.53 1.591L1.875 8l6.364 6.364 5.833-5.834-.795-5.568zM9.3 6.94a1.5 1.5 0 1 1 2.121-2.121A1.5 1.5 0 0 1 9.3 6.939"
  })));
};
export default SvgIconCouponTag;